import { render, staticRenderFns } from "./LoginCard.vue?vue&type=template&id=2c1776f2&scoped=true"
import script from "./LoginCard.vue?vue&type=script&lang=js"
export * from "./LoginCard.vue?vue&type=script&lang=js"
import style0 from "./LoginCard.vue?vue&type=style&index=0&id=2c1776f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1776f2",
  null
  
)

export default component.exports